'use client';

import type { FC } from 'react';
import { useId } from 'react';
import type { VectorName } from '@/ui/components/VectorGraphic/VectorGraphic';
import Button from '@/ui/components/Button/Button';
import Typography from '@/ui/components/Typography/Typography';
import cn from '@/ui/utils/cn/cn';

import $ from './Alert.module.scss';

export type AlertType = 'success' | 'error' | 'warning' | 'info';
export type AlertProps = {
  type?: AlertType;
  icon?: VectorName;
  message: string;
  actionText?: string;
  onAction?: () => void;
  className?: string;
};

const Alert: FC<AlertProps> = ({
  type = 'info',
  message,
  actionText,
  onAction,
  className,
}) => {
  const messageId = useId();

  return (
    <div
      className={cn($.container, $[type], className)}
      role="alert"
      aria-describedby={messageId}
    >
      <Typography id={messageId} variant="bodySmall" weight="medium">
        {message}
      </Typography>
      {actionText && onAction && (
        <Button
          type="button"
          variant="tertiary"
          className={$.action}
          onClick={onAction}
        >
          {actionText}
        </Button>
      )}
    </div>
  );
};

export default Alert;
